var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.1 480",
    style: {
      enableBackground: "new 0 0 512.1 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#244277;}\n\t.st1{fill:#2A6DFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.5,412.9C496.3,382,512,343.8,512,304c0-49.8-24.6-94.9-64-126.9C447.1,291.2,339.8,384,208,384h-89.2 c34.5,56.9,104.6,96,185.2,96h192c6.5,0,12.3-3.9,14.8-9.9c2.5-6,1.1-12.9-3.5-17.4L467.5,412.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208,0C93.3,0,0,78.9,0,176c0,39.8,15.7,77.9,44.5,108.9L4.7,324.7c-4.6,4.6-6,11.5-3.5,17.4 c2.5,6,8.3,9.9,14.8,9.9h192c114.7,0,208-78.9,208-176S322.7,0,208,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHover);
export default __webpack_public_path__ + "static/media/chat_hover.0220d913c6836a5b039b68157bda2ade.svg";
export { ForwardRef as ReactComponent };